import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, getArticlesByCategory, getLatestArticles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find(c => c.slug === slug);
  const categoryArticles = slug ? getArticlesByCategory(slug) : [];
  const allLatest = getLatestArticles(20);

  const displayArticles = slug ? categoryArticles : allLatest;
  const pageTitle = category ? category.name : '全部分类';
  const pageDescription = category ? category.description : '浏览51吃瓜大赛全部分类资讯，网红塌房、明星黑料、每日大赛、吃瓜视频、黑料曝光、八卦杂谈——六大频道一网打尽';

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <section className="w-full py-12 md:py-16 bg-background-100">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              {category ? (
                <>
                  <Link to="/category/wanghong-tafang" className="hover:text-primary-600 transition-colors cursor-pointer">分类浏览</Link>
                  <i className="ri-arrow-right-s-line"></i>
                  <span className="text-foreground-800 font-medium">{category.name}</span>
                </>
              ) : (
                <span className="text-foreground-800 font-medium">全部分类</span>
              )}
            </nav>

            <div className="text-center mb-8">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                {pageTitle}
              </h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                {pageDescription}
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-2 justify-center mb-10">
              <Link
                to="/category/wanghong-tafang"
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  slug === 'wanghong-tafang'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                }`}
              >
                网红塌房
              </Link>
              <Link
                to="/category/mingxing-heiliao"
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  slug === 'mingxing-heiliao'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                }`}
              >
                明星黑料
              </Link>
              <Link
                to="/category/meiri-dasai"
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  slug === 'meiri-dasai'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                }`}
              >
                每日大赛
              </Link>
              <Link
                to="/category/chigua-shipin"
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  slug === 'chigua-shipin'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                }`}
              >
                吃瓜视频
              </Link>
              <Link
                to="/category/heiliao-baoguang"
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  slug === 'heiliao-baoguang'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                }`}
              >
                黑料曝光
              </Link>
              <Link
                to="/category/bagua-zatan"
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  slug === 'bagua-zatan'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                }`}
              >
                八卦杂谈
              </Link>
            </div>
          </div>
        </section>

        <section className="w-full py-12 md:py-16 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="flex items-end justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  {category ? `${category.name}资讯` : '最新资讯'}
                </h2>
                <p className="text-sm text-foreground-500 mt-1">共 {displayArticles.length} 篇相关吃瓜</p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {displayArticles.map((article) => (
                <article key={article.id} className="group">
                  <Link to={`/article/${article.id}`} className="block cursor-pointer">
                    <div className="relative aspect-[16/11] rounded-xl overflow-hidden mb-3">
                      <img
                        src={article.imageUrl}
                        alt={article.imageAlt}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      {article.isTrending && (
                        <span className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-1 rounded-md bg-accent-500 text-background-50 text-[10px] font-medium">
                          <i className="ri-fire-line text-xs"></i>
                          热榜
                        </span>
                      )}
                    </div>
                    <span className="inline-block text-[11px] font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded mb-2">
                      {article.category}
                    </span>
                    <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-2">
                      {article.title}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views.toLocaleString()}
                      </span>
                      <span className="ml-auto">{article.publishDate}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-16 md:py-20 bg-primary-500">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              还有更多大瓜等着你
            </h2>
            <p className="text-sm md:text-base text-background-50/80 mb-6">
              51吃瓜大赛每日更新最新爆料，网红塌房、明星黑料、热门大赛实时追踪
            </p>
            <Link
              to="/category/meiri-dasai"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-medium rounded-lg hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line"></i>
              进入吃瓜大赛
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}